import React, { PureComponent } from 'react';
import PT from 'prop-types';
import { ReactFormGroupWrapper } from './reactformgroupwrapper';
import { map, range } from 'lodash';

const tr = require('ts-translate-js').default.boundTR;

const moment = require('moment');

export class ReactFormFieldDateCombos extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            selYear: -1, selMonth: -1, selDay: -1, selectedDate: null // Hate this but this allow selector to partially select a year before selecting amonth and then a day... We have to keep a temp state to prevent reacting like a dick when the date is not yet valid.
        };

        this.componentDidMount = this.componentDidMount.bind(this);
        this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
        this.handleYearChange = this.handleYearChange.bind(this);
        this.handleMonthChange = this.handleMonthChange.bind(this);
        this.handleDayChange = this.handleDayChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.refreshDate = this.refreshDate.bind(this);
        this.getChangedDate = this.getChangedDate.bind(this);
    }

    componentDidMount() {
        this.refreshDate(this.props.value);
    }

    componentWillReceiveProps(nextProps) {
        this.refreshDate(nextProps.value);
    }

    
    handleYearChange(e) { this.setState({ selYear: parseInt(e.target.value) }, this.handleDateChange); }
    handleMonthChange(e) { this.setState({ selMonth: parseInt(e.target.value) }, this.handleDateChange); }
    handleDayChange(e) { this.setState({ selDay: parseInt(e.target.value) }, this.handleDateChange); }
    
    handleDateChange() {
        const newDate = this.getChangedDate(this.state.selYear, this.state.selMonth, this.state.selDay);
        
        if(this.props.onChange) {
            this.props.onChange(newDate);
        }
    }

    refreshDate(date) {
        let newDate = null;
        if(date) {
            newDate = moment(date);
            
            this.setState({ selYear: newDate.year(), selMonth: newDate.month(), selDay: newDate.date(), selectedDate: newDate });
        } else {
            if(!this.props.showYear)
                this.setState({ selYear: 2000 });

            if(date == null && this.state.selectedDate !== null)
                this.setState({ selYear: -1, selMonth: -1, selDay: -1, selectedDate: null });
        }
    }
    
    getChangedDate(selYear, selMonth, selDay) {
        let newDate;

        let hasBeenRefreshDate = false;

        hasBeenRefreshDate = (this.props.showYear) ? this.state.selYear !== -1 && this.state.selMonth !== -1 && this.state.selDay !== -1 : this.state.selMonth !== -1 && this.state.selDay !== -1;
        
        if(hasBeenRefreshDate)
            newDate = moment({ y: selYear, M: selMonth, d: selDay });
        else
            newDate = null;

        this.setState({ selectedDate : newDate });
        
        return newDate;
    }

    getDefaultOptionCtl(label) { return (<option key="-1" value="-1">{label}</option>); }
    
    render() {
        let age = null;
        
        const endYear = moment().year();
        const startYear = endYear - this.props.yearsFromNow;

        let simulateDate = moment();

        if(this.state.selYear !== -1 && this.state.selMonth !== -1)
            simulateDate = moment([this.state.selYear, this.state.selMonth]);
        
        const lastDayOfTheMonth = (simulateDate) ? moment(simulateDate).endOf('month').date() : 31;

        const [ selectedYear, selectedMonth, selectedDay ] = [ this.state.selYear, this.state.selMonth, this.state.selDay ]; // Temp states for if the date is not yet valid.

        const selectedDate = moment([selectedYear, selectedMonth, selectedDay]);

        // Calculate the age of the person for fun
        if(selectedYear !== -1 && selectedMonth !== -1 && selectedDay !== -1 && this.props.showAge)
            age = moment().diff(selectedDate, 'years');
        
        
        // Years
        const yearsOptions = map(range(endYear, startYear, -1), (y) => <option key={y} value={y}>{y}</option>);
        yearsOptions.unshift(this.getDefaultOptionCtl(tr("année")));
        // Months
        const monthsOptions = map(range(0, 11 + 1), (m) => (<option key={m} value={m}>{moment().month(m).format("MMMM")}</option>) );
        monthsOptions.unshift(this.getDefaultOptionCtl(tr("mois")));
        // Days
        const daysOptions = map(range(1, lastDayOfTheMonth + 1), (d) => <option key={d} value={d}>{d}</option>);
        daysOptions.unshift(this.getDefaultOptionCtl(tr("jour")));
        
        const DateCombosView = this.props.viewProvider.getDateCombosView();

        return (
            <ReactFormGroupWrapper {...this.props}>
                <DateCombosView
                    name={this.props.name}
                    selectedYear={selectedYear}
                    selectedMonth={selectedMonth}
                    selectedDay={selectedDay}
                    yearsOptions={yearsOptions}
                    monthsOptions={monthsOptions}
                    daysOptions={daysOptions}
                    age={age}
                    onYearChange={this.handleYearChange}
                    onMonthChange={this.handleMonthChange}
                    onDayChange={this.handleDayChange}
                    showYear={this.props.showYear}
                    showValidationErrors={this.props.showValidationErrors}
                    isInvalid={this.props.showValidationErrors}
                />
            </ReactFormGroupWrapper>
        );
    }
}

ReactFormFieldDateCombos.propTypes = {
    name: PT.string.isRequired,
    value: PT.instanceOf(moment),
    onChange: PT.func,
    validationErrors: PT.array,
    showAge: PT.bool,
    yearsFromNow: PT.number,
    showValidationErrors: PT.bool,
    viewProvider: PT.object,
    showYear: PT.bool,
    isMultilingual: PT.bool,
    lang: PT.string
};

ReactFormFieldDateCombos.defaultProps = {
    value: null,
    yearsFromNow: 120, // Change this to set a relative number of years to show from now
    showAge: true,
    showYear: true
};

